var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "congratz-step" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "front-vis" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "inn-content" },
        [
          _c("span", { staticClass: "caption ft-xbld txt-grt" }, [
            _vm._v("Congrats, all is done! "),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Thank you for trusting BEE Selfcare, we just sent you all information into your mailbox."
            ),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "btn main lrg gbck",
              attrs: { tag: "a", to: "/dashboard" },
            },
            [
              _c("span", { staticClass: "hvr" }),
              _vm._v(" "),
              _c("span", { staticClass: "txt" }, [
                _vm._v("Go to the administration page"),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "back-vis" }, [
      _c("div", { staticClass: "one" }),
      _vm._v(" "),
      _c("div", { staticClass: "two" }),
      _vm._v(" "),
      _c("div", { staticClass: "three" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }